export default "__VITE_ASSET__6fe97403__"